import { Dialog } from 'primeng/dialog';
import { ChangeDetectionStrategy, Component, model } from '@angular/core';

import { SupportRequestFormComponent } from '../support-request-form/support-request-form.component';

@Component({
	selector: 'app-support-request-dialog',
	templateUrl: './support-request-dialog.component.html',
	imports: [Dialog, SupportRequestFormComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SupportRequestDialogComponent {
	public visible = model<boolean>(false);

	/**
	 * Closes the dialog by setting the visibility to false.
	 */
	public closeDialog(): void {
		this.visible.set(false);
	}

	/**
	 * Handles successful form submission.
	 */
	public onFormSubmitted(): void {
		this.closeDialog();
	}
}
